var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ic-form__buttons" }, [
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12" },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { disabled: _vm.sending },
              on: {
                click: function ($event) {
                  return _vm.$emit("click")
                },
              },
            },
            [
              !_vm.error && !_vm.sending
                ? _c("span", [_vm._v(_vm._s(_vm.$t("label_send_button")))])
                : _vm._e(),
              _vm._v(" "),
              _vm.error
                ? _c("span", [_vm._v(_vm._s(_vm.$t("label_resend_button")))])
                : _vm._e(),
              _vm._v(" "),
              _vm.sending
                ? _c("span", [_vm._v(_vm._s(_vm.$t("label_sending_button")))])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _vm.sending
            ? _c("vue-loading", {
                attrs: {
                  type: "spin",
                  color: "#0071BC",
                  size: { width: "50px", height: "50px" },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.error
            ? _c("div", { staticClass: "ic-form__error" }, [
                _vm._v(_vm._s(_vm.message)),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }